module.exports = __webpack_public_path__ + "static/media/green-contact.64488c00.jpg";